"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var Block = function Block(_ref) {
  var handleOnClick = _ref.handleOnClick,
    backgroundImage = _ref.backgroundImage,
    title = _ref.title,
    subtitle = _ref.subtitle,
    titleIcon = _ref.titleIcon,
    mainIcon = _ref.mainIcon,
    description = _ref.description,
    highlight = _ref.highlight,
    disabled = _ref.disabled,
    disabledText = _ref.disabledText,
    cta = _ref.cta;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('blocks-view-block', {
      disabled: disabled
    })
  }, handleOnClick ? {
    onClick: handleOnClick,
    role: 'button',
    'aria-pressed': false,
    tabIndex: 0
  } : {}), /*#__PURE__*/_react["default"].createElement("div", {
    className: "image-well relative",
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content__wrapper relative max-width-xxxs margin-auto text-center"
  }, titleIcon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "title-icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: titleIcon,
    alt: "".concat(title, " icon")
  })), title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-color-white text-xxxl underline-title margin-bottom-sm"
  }, title), mainIcon && /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      margin: '20px auto',
      maxWidth: 140
    },
    src: mainIcon,
    alt: title
  }), subtitle && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, subtitle === 'Sold Out' ? /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      background: '#FF4949',
      color: '#fff',
      padding: '4px',
      marginLeft: '4px',
      fontSize: '10px'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      width: 10,
      marginRight: 2
    },
    src: "https://assets.theskiweek.com/wp-content/uploads/2019/12/tag-icon.png",
    alt: "sold out"
  }), "SOLD OUT") : /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      marginTop: '0px',
      marginBottom: '20px'
    },
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  })), highlight && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt30 highlights__wrapper"
  }, highlight.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: item,
      className: "md-font white-font bold"
    }, item);
  })), description && /*#__PURE__*/_react["default"].createElement("p", {
    className: "margin-top-sm hidden-xs max-width-xxxxs",
    style: {
      margin: '0px auto'
    }
  }, description), cta && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn--primary btn--md margin-top-md margin-bottom-sm"
  }, cta), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm"
  }, "Price per person")), disabledText && /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: 'red',
      margin: '0px auto',
      marginTop: '10px'
    }
  }, disabledText))));
};
Block.propTypes = {
  handleOnClick: _propTypes["default"].func,
  backgroundImage: _propTypes["default"].string,
  title: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  titleIcon: _propTypes["default"].string,
  mainIcon: _propTypes["default"].string,
  description: _propTypes["default"].string,
  highlight: _propTypes["default"].array,
  disabled: _propTypes["default"].bool,
  disabledText: _propTypes["default"].string,
  cta: _propTypes["default"].node
};
var _default = exports["default"] = Block;